import React from 'react';
import { useWeb3 } from '../context/Web3Context';
import { formatAddress } from '../utils/helpers';
import './BlacklistNotice.css';

const BlacklistNotice = () => {
  const { blacklistedAddress, dismissBlacklistNotice } = useWeb3();

  if (!blacklistedAddress) return null;

  return (
    <div className="blacklist-overlay">
      <div className="blacklist-card">
        <div className="blacklist-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
        </div>
        <h2 className="blacklist-title">Account Blacklisted</h2>
        <p className="blacklist-subtitle">
          This wallet address has been blocked from accessing the platform.
        </p>
        <div className="blacklist-address" title={blacklistedAddress}>
          {formatAddress(blacklistedAddress, 10, 8)}
        </div>
        <p className="blacklist-help">
          If you believe this is a mistake, please contact support. To try a
          different account, switch wallets in MetaMask and reconnect.
        </p>
        <button className="blacklist-btn" onClick={dismissBlacklistNotice}>
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default BlacklistNotice;
